/**
 * Purchase Service
 * Handles all purchase-related API calls
 *
 * @module services/PurchaseService
 */

import BaseService from "core/api/BaseService";

class PurchaseService extends BaseService {
  constructor() {
    super("/purchases");
  }

  async createPaymentIntent(itemId, itemType = "course") {
    return this.post("create-payment-intent", { itemId, itemType, courseId: itemId }); // courseId strictly for backward compat if needed
  }

  async confirmPayment(purchaseId) {
    return this.post(`confirm/${purchaseId}`);
  }

  async getHistory() {
    return this.get("my-purchases");
  }

  async refund(purchaseId, reason) {
    return this.post(`${purchaseId}/refund`, { reason });
  }
}

export default new PurchaseService();
